const components = [
    {
        title: "文本",
        tag: "de-text",
        group: "text",
        props: [
            {
                title: "内容",
                name: "text",
                type: { name: "text" }
            },
            {
                title: "字体",
                name: "textStyle",
                type: { name: "font" }
            },
            {
                title: "宽度",
                name: "width",
                type: { name: "number" }
            },
            {
                title: "行高",
                name: "lineHeight",
                type: { name: "number" }
            }
        ]
    },
    {
        title: "头部标题",
        tag: "de-header-title",
        group: "text",
		defaultSize: {
			width: 620,
			height: 60
		},
        props: [
            {
                title: "标题名",
                name: "headerName",
                type: { name: "text" },
                default: "头部标题"
            },
            {
                title: "字体",
                name: "fontObj",
                type: { name: "font" },
                default: {
                    fontSize: 20,
                    fontFamily: "PingFang",
                    fontWeight: "normal",
                    fontStyle: "normal",
                    color: "#E6F2FF"
                }
            },
            {
                title: "标题行高",
                name: "lineHeight",
                type: { name: "number" },
                default: 60
            },
            {
                title: "左边距",
                name: "paddingLeft",
                type: { name: "number" },
                default: 20
            }
        ]
    },
    {
        title: "头部标题",
        tag: "de-header-title1",
        group: "text",
		defaultSize: {
			width: 1020,
			height: 120
		},
        props: [
            {
                title: "标题名",
                name: "title",
                type: { name: "text" },
                default: "标题"
            },
            {
                title: "类型",
                name: "type",
                type: {
                    name: "select",
                    options: {
                        list: [
                            {
                                label: "标题1",
                                value: 1
                            },
                            {
                                label: "标题2",
                                value: 2
                            },
                            {
                                label: "标题3",
                                value: 3
                            }
                        ]
                    }
                },
                default: {
                    label: "标题1",
                    value: 1
                }
            },
            {
                title: "字体",
                name: "fontObj",
                type: { name: "font" },
                default: {
                    fontSize: 24,
                    fontStyle: "normal",
                    color: "#E6F2FF"
                }
            },
            {
                title: "文字高度",
                name: "lineHeight",
                type: { name: "number" },
                default: 60
            }
        ]
    },
    {
        title: "一级标题",
        tag: "de-one-level-title",
        group: "text",
		defaultSize: {
			width: 460,
			height: 30
		},
        props: [
            {
                title: "标题名",
                name: "title",
                type: { name: "text" },
                default: "一级标题"
            },
            {
                title: "字体",
                name: "fontObj",
                type: { name: "font" },
                default: {
                    fontSize: 16,
                    fontStyle: "normal",
                    color: "#E6F2FF",
                    fontFamily: "PingFang",
                    fontWeight: "normal"
                }
            },
            {
                title: "logo颜色",
                name: "iconColor",
                type: { name: "color" },
                default: '#fff'
            },
            {
                title: "行高",
                name: "lineHeight",
                type: { name: "number" },
                default: 38
            },
            {
                title: "左边距",
                name: "paddingLeft",
                type: { name: "number" },
                default: 10
            },
            {
                title: "宽度",
                name: "bgWidth",
                type: { name: "number" },
                default: 300
            },
            {
                title: "高度",
                name: "bgHeight",
                type: { name: "number" },
                default: 24
            },
            {
                title: "上边距",
                name: "bgMarginTop",
                type: { name: "number" },
                default: 8
            }
        ]
    },
    {
        title: "一级标题",
        tag: "de-one-level-title1",
        group: "text",
		defaultSize: {
			width: 400,
			height: 30
		},
        props: [
            {
                title: '背景色',
                name: 'backColor',
                type: { name: "color" },
                default: "transparent"
            },
            {
                title: "标题名",
                name: "title",
                type: { name: "text" },
                default: "一级标题"
            },
            {
                title: "字体",
                name: "fontObj",
                type: { name: "font" },
                default: {
                    fontSize: 16,
                    fontStyle: "normal",
                    color: "#E6F2FF",
                    fontFamily: "PingFang",
                    fontWeight: "normal"
                }
            },
            {
                title: "logo颜色",
                name: "iconColor",
                type: { name: "color" },
                default: '#0084FF'
            },
            {
                title: "是否显示背景图",
                name: "showPic",
                default: false
            },
            {
                title: "行高",
                name: "lineHeight",
                type: { name: "number" },
                default: 32
            },
            {
                title: "左边距",
                name: "paddingLeft",
                type: { name: "number" },
                default: 10
            }
        ]
    },
    {
        title: "二级标题",
        tag: "de-two-level-title",
        group: "text",
		defaultSize: {
			width: 300,
			height: 30
		},
        props: [
            {
                title: "标题名",
                name: "title",
                type: { name: "text" },
                default: "二级标题"
            },
            {
                title: "字体",
                name: "fontObj",
                type: { name: "font" },
                default: {
                    fontSize: 12,
                    fontStyle: "normal",
                    color: "#fff",
                    fontFamily: "PingFang",
                    fontWeight: "normal"
                }
            },
            {
                title: "标题行高",
                name: "lineHeight",
                type: { name: "number" },
                default: 26
            },
            {
                title: "左边距",
                name: "paddingLeft",
                type: { name: "number" },
                default: 12
            }
        ]
    },
    {
        title: "简介",
        tag: "de-introduce",
        group: "text",
		defaultSize:{
			width:200, height:100
		},
        props: [
            {
                title: "标题",
                name: "title",
                type: { name: "text" },
                default: '2020年底投资'
            },
            {
                title: "数字",
                name: "number",
                type: { name: "text" },
                default: '8'
            },
            {
                title: "内容(前置)",
                name: "preContent",
                type: { name: "text" },
                default: '近'
            },
            {
                title: "内容(后置)",
                name: "postContent",
                type: { name: "text" },
                default: '万亿元'
            },
            {
                title: "字体",
                name: "fontObj",
                type: { name: "font" },
                default: {
                    fontSize: 16,
                    color: '#fff'
                }
            }
        ]
    },
    {
        title: "链接组件",
        tag: "de-link",
        group: "text",
		defaultSize:{
			width:200, height:100
		},
        props: [
            {
                title: "列宽",
                name: "width",
                type: { name: "number" },
                default: 80
            },
            {
                title: "字体",
                name: "fontObj",
                type: { name: "font" }
            },
            {
                title: "数据",
                name: "links",
                type: { name: "data-json" },
                default: (() => {
                    return [{
                        name: '新浪',
                        link: 'www.sina.com'
                    }, {
                        name: '百度',
                        link: 'www.baidu.com'
                    }, {
                        name: '腾讯',
                        link: 'www.tencent.com'
                    }, {
                        name: '淘宝',
                        link: 'www.taobao.com'
                    }, {
                        name: '京东',
                        link: 'www.jd.com'
                    }]
                })()
            }
        ]
    },
    {
		title: '趋势组件',
		tag: 'de-text-percent',
		group: 'text',
		defaultSize:{
			width: 60, 
			height: 30
		},
		props: [
            {
                title: "数值",
                name: "percent",
                type: {
                    name: "percent"
                },
                default: 0
            },
            {
                title: "字体",
                name: "fontObj",
                type: {
                    name: "font"
                },
                default: {
                    fontSize: 16,
                    fontStyle: "normal",
                    fontFamily: "PingFang",
                    fontWeight: "normal"
                }
            },
            {
                title: "间距",
                name: "margin",
                type: {
                    name: "number"
                },
                default: 8
            }
		]
    },
    {
        title: "文本趋势组件",
        tag: "de-text-trend",
        group: "text",
		defaultSize: {
			width: 180,
			height: 70
		},
        props: [
            {
                title: "标题名",
                name: "title",
                type: {
                    name: "text"
                },
                default: "商旅总人数"
            },
            {
                title: "标题字体",
                name: "titleFontObj",
                type: {
                    name: "font"
                },
                default: {
                    fontSize: 12,
                    fontStyle: "normal",
                    color: "#fff",
                    fontFamily: "PingFang",
                    fontWeight: "normal"
                }
            },
            {
                title: "标题行高",
                name: "titleLineHeight",
                type: {
                    name: "number"
                },
                default: 26
            },
            {
                title: "标题边距",
                name: "titlePaddingLeft",
                type: {
                    name: "number",
                    options: {
                        min: 0,
                        max: 100
                    }
                },
                default: 12
            },
            {
                title: "总数",
                name: "sum",
                type: {
                    name: "number"
                },
                default: 321412
            },
            {
                title: "数字字号",
                name: "sumFont",
                type: {
                    name: "number"
                },
                default: 30
            },
            {
                title: "趋势数值",
                name: "percent",
                type: {
                    name: "percent"
                },
                default: 0
            },
            {
                title: "趋势字号",
                name: "percentFont",
                type: {
                    name: "number"
                },
                default: 16
            },
            {
                title: "间距",
                name: "margin",
                type: {
                    name: "number"
                },
                default: 8
            }
        ]
    },
    {
        title: "图文混排(垂直)",
        tag: "de-picture-text-vertical",
        group: "text",
		defaultSize: {
			width: 90,
			height: 100
		},
        props: [  
            {
                title: "图标",
                name: "image",
                type: {
                    name: "image"
                },
                default: ""
            },
            {
                title: "标题",
                name: "title",
                type: {
                    name: "text"
                },
                default: '标题一'
            },
            {
                title: "数值",
                name: "value",
                type: {
                    name: "text"
                },
                default: "0"
            }
        ]
    },
    {
        title: "文字数值排行",
        tag: "de-text-rank-number-percent",
        group: "text",
		defaultSize: {
			width: 180,
			height: 84
		},
        props: [  
            {
                title: "名称",
                name: "name",
                type: {
                    name: "text"
                },
                default: "山东省"
            },
            {
                title: "排行",
                name: "rank",
                type: {
                    name: "text"
                },
                default: '1'
            },
            {
                title: "总数",
                name: "total",
                type: {
                    name: "text"
                },
                default: "2000"
            },
            {
                title: "占比",
                name: "percent",
                type: {
                    name: "text"
                },
                default: "30"
            }
        ]
    },
    {
       title: "全局菜单",
       tag: "de-layout-menu",
       group: "text",
       defaultSize: {
           width: 180,
           height: 60
       },
       events:[
            {
                name:'update-iframe-link',
                title:'更新iframe地址'
            },
            {
                name:'layout-menu-click',
                title:'点击事件'
            }
        ],
        props: [
            {
                title: '新标签',
                name: 'blank',
                type:  {
                    name: 'bool'
                },
                default: true
            },
            {
                title: '名称',
                name: 'name',
                type:  {
                    name: 'text'
                },
                default: '菜单名称'
            },
            {
                title: "字体",
                name: "fontObj",
                type: { name: "font" },
                default: {
                    fontSize: 16,
                    fontStyle: "normal",
                    color: "#E6F2FF",
                    fontFamily: "PingFang",
                    fontWeight: "normal"
                }
            },
            {
                title: '链接地址',
                name: 'link',
                type:  {
                    name: 'text'
                },
                default: ''
            }
        ]
    },
    {
        title: "全局菜单组",
        tag: "de-layout-menu-group",
        group: "text",
        defaultSize: {
            width: 360,
            height: 60
        },
        events:[
             {
                 name:'update-iframe-link',
                 title:'更新iframe地址'
             },
             {
                 name:'layout-menu-click',
                 title:'点击事件'
             }
         ],
         props: [
             {
                 title: '新标签',
                 name: 'blank',
                 type:  {
                     name: 'bool'
                 },
                 default: true
             },
             {
                title: '默认背景',
                name: 'backColor',
                type: { name: "color" },
                default: ""
            },
            {
                title: '选中背景',
                name: 'currentBackColor',
                type: { name: "color" },
                default: ""
            },
            {
                title: '边框颜色',
                name: 'borderColor',
                type: { name: "color" },
                default: "#2081EA"
            },
             {
                 title: "字体",
                 name: "fontObj",
                 type: { name: "font" },
                 default: {
                     fontSize: 16,
                     fontStyle: "normal",
                     color: "#E6F2FF",
                     fontFamily: "PingFang",
                     fontWeight: "normal"
                 }
             },
             {
                 title: '链接地址',
                 name: 'link',
                 type:  {
                     name: 'text'
                 },
                 default: ''
             },
             {
				title: '数据',
				name: 'menus',
				type: {
					name: 'data-json'
				},
				default: [
                    {
                        name: '菜单组1',
                        content: '菜单描述',
                        link: 'http://www.talkingdata.com'
                    },
                    {
                        name: '菜单组2',
                        content: '菜单描述2',
                        link: 'http://www.baidu.com'
                    }
                ]
			}
         ]
    },
    {
    title: "移动顶部菜单",
    tag: "de-mobile-header-menu",
    group: "text",
    defaultSize: {
        width: 320,
        height: 60
    },
    events:[],
        props: [
        {
            title: '默认背景',
            name: 'backColor',
            type: { name: "color" },
            default: "#2185F0"
        },
            {
                title: "字体",
                name: "fontObj",
                type: { name: "font" },
                default: {
                    fontSize: 16,
                    fontStyle: "normal",
                    color: "#E6F2FF",
                    fontFamily: "PingFang",
                    fontWeight: "normal"
                }
            },
            {
            title: '数据',
            name: 'menus',
            type: {
                name: 'data-json'
            },
            default: [
                {
                    name: '首页',
                    link: 'http://www.talkingdata.com'
                },
                {
                    name: '菜单一',
                    link: 'http://www.baidu.com'
                }
            ]
        }
        ]
    },
    // {
    //     title: "列表/表格",
    //     tag: "de-table",
    //     group: "text",
	// 	defaultSize:{
	// 		width:200, height:100
	// 	},
    //     props: [
    //         {
    //             title: "字体",
    //             name: "fontObj",
    //             type: { name: "font" }
    //         },
    //         {
    //             title: "标题数据",
    //             name: "titleArr",
    //             type: { name: "data-json" },
    //             default: (() => {
    //                 return [
    //                     {
    //                         title: '领域',
    //                         key: 'name',
    //                         width: 100
    //                     },
    //                     {
    //                         title: '建设内容',
    //                         key: 'age'
    //                     },
    //                     {
    //                         title: '目标',
    //                         key: 'address'
    //                     }
    //                 ]
    //             })()
    //         },
    //         {
    //             title: "数据",
    //             name: "listData",
    //             type: { name: "data-json" },
    //             default: (() => {
    //                 return [{
    //                     name: 'John Brown',
    //                     age: 18,
    //                     address: 'New York No. 1 Lake Park'
    //                 },
    //                 {
    //                     name: 'Jim Green',
    //                     age: 24,
    //                     address: 'London No. 1 Lake Park'
    //                 },
    //                 {
    //                     name: 'Joe Black',
    //                     age: 30,
    //                     address: 'Sydney No. 1 Lake Park'
    //                 },
    //                 {
    //                     name: 'Jon Snow',
    //                     age: 26,
    //                     address: 'Ottawa No. 2 Lake Park'
    //                 }]
    //             })()
    //         }
    //     ]
    // }
];
export default components;
